export default __webpack_public_path__ + "static/media/VAT_Arabic.8ad90975.png";